import PropertyInformationIcon from '../../../resources/vectors/PropertyInformationIcon'
import ContractSigningIcon from '../../../resources/vectors/ContractSigningIcon'
import Commercial from '../../../resources/vectors/Commercial'
import React from 'react';
import PropertyInformation from './Components/TabContent/PropertyInformation';
import TrendingUpRoundedIcon from '@material-ui/icons/TrendingUpRounded';
import CommercialDetails from './Components/TabContent/CommercialDetails';
import ContractSigning from './Components/TabContent/ContractSigning';
import GoLive from './Components/TabContent/GoLive';

const stageMap = {
    // just in case
    '':{
        getIcon: () => null,
        getTabContent: () => null
    },
    property_information:{
        key:1,
        translation:"Property Information",
        getIcon: (style) => <PropertyInformationIcon style={{...style,padding:'8px'}} color={style.color}/>,
        getTabContent: (viewMode, props) => <PropertyInformation viewMode={viewMode} {...props} />
    },
    commercial_details:{
        key:2,
        translation:"Commercials",
        getIcon: (style) => <Commercial style={{...style,padding:'8px'}} color={style.color}/>,
        getTabContent: (viewMode) => <CommercialDetails viewMode={viewMode}/>
    },
    contract_signing:{
        key:3,
        translation:"Contract",
        getIcon: (style) => <ContractSigningIcon style={{...style,padding:'9px'}} color={style.color}/>,
        getTabContent: (viewMode) => <ContractSigning viewMode={viewMode}/>
    },
    setup_and_go_live:{
        key:5,
        translation:"Go Live",
        getIcon: (style) => <TrendingUpRoundedIcon style={{...style,padding:'6px'}}/>,
        getTabContent: (viewMode) => <GoLive viewMode={viewMode}/>
    }
};

Object.freeze(stageMap);

export default stageMap;